<template>

  <div id="app" tabindex="-1">
    <title-container :title="'My Membership'"></title-container>
    <nav-bar :tabs="navBarTabs"></nav-bar>
    <router-view></router-view>
  </div>

</template>

<script>
  import { TitleContainer, NavBar } from 'my-account-common-vue'

  export default {
    components: {
      TitleContainer,
      NavBar
    },
    methods: {
    },
    data () {
      return {
        navBarTabs: [
          { name: 'Agreements', route: 'Agreements' },
          { name: 'Personal Training', route: 'PersonalTraining' },
          { name: 'Club Visits', route: 'ClubVisits' }
        ]
      }
    },
    name: 'app'
  }
</script>

<style lang="scss">
  $fa-font-path: "~font-awesome/fonts";
  @import "~font-awesome/scss/font-awesome";
  @import '~my-account-common-css/stylesheets/print.scss';
  @import '~my-account-common-css/stylesheets/vue-toast-customization.scss';
  @import '~my-account-common-css/stylesheets/container.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue